import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const FUNNY_ABOUT = [
  "I turn caffeine into deployed code. My best work happens at 3 AM when the debugging gods are watching.",
  "I specialize in Googling error messages and blaming caching for everything that goes wrong."
];

const About = ({ t }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <section className="about">
      <div className="about__content">
        <h2 className="h2">{t.title}</h2>
        <div
          className={`about__text ${hovered ? 'about__text--hovered' : ''}`}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          {(hovered ? FUNNY_ABOUT : t.description).map((text, index) => (
            <p key={index} className="about__description">{text}</p>
          ))}
        </div>
        <Link to="/about-me" className="button">{t.button} -&gt;</Link>
      </div>
      <img src="/images/about-me.png" alt="" className="about__image" />
    </section>
  );
};

export default About;
